import React from 'react';

class SMSearchRentTypeView extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  onChange(e) {
    if(this.props.delegate && typeof this.props.delegate.rentTypeDidChange === 'function'){
      this.props.delegate.rentTypeDidChange(e);
    }
  }
  
  renderRows() {
    const priceType = this.props.priceType;
    let types = priceType && priceType != "" ? priceType.split(",") : [];
    let rows = [];
    let items = [
      {label: I18n.t("service.label_000015"), value: "hourly"},
      {label: I18n.t("service.label_000016"), value: "daily"},
      {label: I18n.t("service.label_000017"), value: "stay"},
    ];
    items.forEach((item, index)=>{
      const id = this.props.options.className + "price-type__checkbox" + index;

      rows.push(
        <li key={id}>
          <input 
            type="checkbox"
            onChange={this.onChange.bind(this)}
            checked={types.indexOf(item.value) != -1}
            value={item.value} 
            id={id} />
          <label 
            htmlFor={id} 
            className="form-checkbox__s">{item.label}</label>
        </li>
      );
    });
    return rows;
  }
  
  render() {

    return (
      <ul className={this.props.options.className}>
        {this.renderRows()}
        <input type="hidden" name="price_type" value={this.props.priceType} />
      </ul>
    );
  }
}
export default SMSearchRentTypeView;




// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchRentTypeView.jsx